import { useUnit } from 'effector-react';
import { Button, Card, Space, Switch, Tooltip } from 'antd';
import { useEffect, useState } from 'react';
import { CheckOutlined, DownOutlined, UpOutlined } from '@ant-design/icons';
import { useLocation } from 'react-router-dom';
import style from './MapGradient.module.css';
import { $activeFilters } from '../../models/activeFiltersModel/index.js';
import {
  $blockedBuckets,
  $gradientBuckets,
  $gradientBucketsDist,
  $gradientBucketsHexagons,
} from '../../models/gradientModel/index.js';
import { $mapLoaded } from '../../models/mapModel/index.js';
import { formatNumberCompact } from '../../utils/format-utils.js';
import useWindowSize from '../../hooks/useWindowSize.js';
import {
  $activeModal,
  $hexProperty,
  $regionsLayer,
} from '../../models/investProModel/index.js';
import { layers_dictionary } from '../../dictionaries/layers_dictionary.js';
import useMapZoom from '../../hooks/useMapZoom.js';
import { heatmap_layer_names } from '../../dictionaries/heatmap_layer_names.js';

export default function MapGradient() {
  const mapLoaded = useUnit($mapLoaded);
  const gradientBuckets = useUnit($gradientBuckets);
  const gradientBucketsDist = useUnit($gradientBucketsDist);
  const gradientBucketsHexagons = useUnit($gradientBucketsHexagons);
  const blockedBuckets = useUnit($blockedBuckets);
  const { pathname } = useLocation();
  const hideNumbers = false;
  const [blockLevel, setBlockLevel] = useState('zoom_8');
  const [width, height] = useWindowSize();
  const [expanded, setExpanded] = useState(true);
  const regionsLayer = useUnit($regionsLayer);
  const zoom = useMapZoom();
  const activeModal = useUnit($activeModal);
  const hexProperty = useUnit($hexProperty);

  let bucketsCopy;
  let colorsCopy;
  if (zoom < 5) {
    bucketsCopy = gradientBuckets.buckets;
    colorsCopy = gradientBuckets.colors;
  } else {
    bucketsCopy = gradientBucketsDist.buckets;
    colorsCopy = gradientBucketsDist.colors;
  }

  if (activeModal === 'heatmap') {
    bucketsCopy = gradientBucketsHexagons.buckets;
    if (hexProperty === 'hhi') {
      colorsCopy = [...gradientBucketsHexagons.colors].reverse();
    } else {
      colorsCopy = gradientBucketsHexagons.colors;
    }
  }

  let title = layers_dictionary[regionsLayer];
  if (activeModal === 'heatmap') {
    title = heatmap_layer_names[hexProperty];
  }

  return (
    <div className={style.bottom_bar_wrapper}>
      <Card
        className={[style.gradient_wrapper, 'glass'].join(' ')}
        bodyStyle={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        {pathname === '/center-home' && width < 500 ? (
          <Button
            className={style.mobile_close_button}
            shape="circle"
            icon={<DownOutlined />}
            onClick={() => setExpanded(false)}
          />
        ) : null}
        <div>
          <div
            className={style.gradient_top}
            style={{
              justifyContent:
                pathname !== '/public' || pathname === '/lite'
                  ? 'flex-start'
                  : 'center',
            }}
          >
            <div className={style.gradient_by_wrapper}>
              <Tooltip title={title} placement="top">
                <div className={style.gradient_title}>{title}</div>
              </Tooltip>
            </div>
          </div>
          <Space
            size="small"
            style={{
              display: 'flex',
              justifyContent: 'center',
              flexWrap: width < 500 ? 'wrap' : 'nowrap',
              rowGap: 20,
            }}
          >
            {hideNumbers && (
              <div className={style.bucket_wrapper}>
                <div className={style.bucket} style={{ color: 'black' }}>
                  Низкий
                </div>
              </div>
            )}
            {bucketsCopy.map((item, index) => {
              if (index !== bucketsCopy.length - 1) {
                return (
                  <>
                    {!hideNumbers && (
                      <div className={style.bucket_wrapper}>
                        <div
                          className={style.bucket}
                          style={{ color: 'white' }}
                        >
                          {formatNumberCompact(item)}
                        </div>
                      </div>
                    )}
                    <GradientItem
                      key={`${item}${index}`}
                      maxValue={bucketsCopy[index + 1] || 0}
                      minValue={item}
                      color={colorsCopy[index]}
                      blockedBuckets={blockedBuckets[blockLevel]}
                      isLast={index === bucketsCopy.length - 2}
                    />
                    {index === bucketsCopy.length - 2 && !hideNumbers && (
                      <div className={style.bucket_wrapper}>
                        <div
                          className={style.bucket}
                          style={{ color: 'white' }}
                        >
                          {bucketsCopy[index + 1] === Infinity
                            ? '∞'
                            : formatNumberCompact(bucketsCopy[index + 1])}
                        </div>
                      </div>
                    )}
                  </>
                );
              }
            })}
            {hideNumbers && (
              <div className={style.bucket_wrapper}>
                <div className={style.bucket} style={{ color: 'black' }}>
                  Высокий
                </div>
              </div>
            )}
          </Space>
        </div>
      </Card>
    </div>
  );
}

function GradientItem({ color, maxValue, minValue }) {
  return (
    <div
      className={[style.gradient_item].join(' ')}
      style={{
        background: color,
        cursor: 'default',
        boxShadow: 'none',
      }}
    />
  );
}
